//=> Import React
import React, { useState } from "react";
//=> Import plugins
import { useSendEmail } from "../../utils/useSendEmail";

//=> Import component
import Layout from "../../component/Layout";
import Header from "../../component/Header";
import NavBar from "../../component/NavBar";
import Footer from "../../component/Footer";
import Divider from "../../component/Divider";
import SEO from '../../component/SEO'

//=> Import Styles
import {
  titleInfo,
  title,
  presentation,
  form,
  label,
  input,
  textarea,
  button,
  messageError,
  successMessageSubmit,
  contentContainer
} from "./styles.module.scss";
import { useEffect } from "react";

//=> Component
const Info = () => {
  const [userForm, setUserForm] = useState({
    name: "",
    mail: "",
    message: "",
  });
  const [completeData, setCompleteData] = useState(false);
  const [displaySuccessMessage, setDisplaySuccessMessage] = useState(false);

  const [errorForm, setErrorForm] = useState(false);
  // => Variable pour savoir de qul input vient l'error
  const [typeInputError, setTypeInputError] = useState("");

  // => Input onChange
  const onChangeForm = (evt) => {
    setUserForm(() => {
      return {
        ...userForm,
        [evt.target.id]: evt.target.value,
      };
    });
  };

  // => Error Form
  const formError = (inputName) => {
    setErrorForm(true);
    setTypeInputError(inputName);

    setTimeout(() => {
      setErrorForm(false);
      setTypeInputError("");
    }, 3000);
  };

  const [success, _, error] = useSendEmail(userForm, completeData);

  useEffect(() => {
    if (success) setDisplaySuccessMessage(true);

    setTimeout(() => {
      setDisplaySuccessMessage(false);
    }, 3000);
  }, [success]);

  const onSubmitForm = async (evt) => {
    evt.preventDefault();

    // => Control input valide
    if (userForm.name.trim() === "") {
      formError("name");
      return;
    } else if (userForm.mail.trim() === "") {
      formError("mail");
      return;
    } else if (userForm.message.trim() === "") {
      formError("message");
      return;
    }

    setCompleteData(true);
    // Reset Inputs
    setTimeout(() => {
      setUserForm({
        name: "",
        mail: "",
        message: "",
      });
      setCompleteData(false);
    }, 1000);
  };

  return (
    <Layout>
      <SEO title={"Information"} />
      <Header />
      <NavBar />
      <div className={contentContainer}>
        <h2 className={titleInfo}> Information et contact</h2>
        <div className={presentation}>
          <h4 id="consigne" className={title}>Notre système de consigne</h4>
          <Divider />
          <div>
            <p>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Impedit
              distinctio nesciunt necessitatibus sed fugiat perspiciatis
              praesentium mollitia eaque deserunt nisi, doloribus consectetur
              maiores, cumque nam quas quia dolore quae eveniet.
            </p>
            <p>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Impedit
              distinctio nesciunt necessitatibus sed fugiat perspiciatis
              praesentium mollitia eaque deserunt nisi, doloribus consectetur
              maiores, cumque nam quas quia dolore quae eveniet.
            </p>
          </div>
          {" "}
          <h4 className={title}>Retrait boutique</h4>
          <Divider />
          <div>
            <p>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Impedit
              distinctio nesciunt necessitatibus sed fugiat perspiciatis
              praesentium mollitia eaque deserunt nisi, doloribus consectetur
              maiores, cumque nam quas quia dolore quae eveniet.
            </p>
            <p>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Impedit
              distinctio nesciunt necessitatibus sed fugiat perspiciatis
              praesentium mollitia eaque deserunt nisi, doloribus consectetur
              maiores, cumque nam quas quia dolore quae eveniet.
            </p>
          </div>
          <h4 className={title}>Livraison Carcassonne et alentours</h4>
          <Divider />
          <div>
            <p>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Impedit
              distinctio nesciunt necessitatibus sed fugiat perspiciatis
              praesentium mollitia eaque deserunt nisi, doloribus consectetur
              maiores, cumque nam quas quia dolore quae eveniet.
            </p>
            <p>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Impedit
              distinctio nesciunt necessitatibus sed fugiat perspiciatis
              praesentium mollitia eaque deserunt nisi, doloribus consectetur
              maiores, cumque nam quas quia dolore quae eveniet.
            </p>
          </div>
          <h4 className={title}>Livraison en france métropolitaine</h4>
          <Divider />
          <div>
            <p>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Impedit
              distinctio nesciunt necessitatibus sed fugiat perspiciatis
              praesentium mollitia eaque deserunt nisi, doloribus consectetur
              maiores, cumque nam quas quia dolore quae eveniet.
            </p>
            <p>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Impedit
              distinctio nesciunt necessitatibus sed fugiat perspiciatis
              praesentium mollitia eaque deserunt nisi, doloribus consectetur
              maiores, cumque nam quas quia dolore quae eveniet.
            </p>
          </div>
          <h4 className={title}>Nous contacter</h4>
          <Divider />
          <div>
            <p>
              ➡ Téléphone: <a href="#">06 50 ** ** **</a>
            </p>
            <p>
              ➡ Mail: <a href="cindypenez@gmail.com">cindypenez@gmail.com</a>
            </p>
            <p>➡ Ou avec le formulaire ci-dessous ⬇</p>
          </div>
        </div>

        <form className={form} onSubmit={onSubmitForm}>
          {errorForm && (
            <p className={messageError}>
              {" "}
              Veuillez remplir tous les champs correctement s'il vous plait.{" "}
            </p>
          )}
          {displaySuccessMessage && (
            <p className={successMessageSubmit}>Merci pour votre message</p>
          )}
          <label className={label} htmlFor="name">
            Votre nom(obligatoire)
          </label>
          <input
            onChange={(evt) => {
              onChangeForm(evt);
            }}
            value={userForm.name}
            required
            className={`${input} ${errorForm && typeInputError === "name" && error
              }`}
            type="text"
            id="name"
          />
          <label className={label} htmlFor="mail">
            Votre mail(obligatoire)
          </label>
          <input
            onChange={(evt) => {
              onChangeForm(evt);
            }}
            value={userForm.mail}
            required
            className={`${input} ${errorForm && typeInputError === "mail" && error
              }`}
            type="email"
            id="mail"
          />
          <label className={label} htmlFor="message">
            Votre message(obligatoire)
          </label>
          <textarea
            onChange={(evt) => {
              onChangeForm(evt);
            }}
            value={userForm.message}
            required
            className={textarea}
            id="message"
          ></textarea>
          <button className={button} type="submit">
            Envoyer
          </button>
        </form>
        <h4 className={title}>Où nous trouver:</h4>
        <Divider />
        {/* Map */}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2907.845170661475!2d2.34784881616829!3d43.21273668881714!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12ae2c373b782f6d%3A0xe10be9e8c97dcf97!2s72%20Rue%20de%20Verdun%2C%2011000%20Carcassonne!5e0!3m2!1sfr!2sfr!4v1643986394916!5m2!1sfr!2sfr"
          height="450"
          style={{ border: 0, width: "100%" }}
          loading="lazy"
        ></iframe>
      </div>
      <Footer />
    </Layout>
  );
};

export default Info;
